import { endpointWrapper } from './meta.api';

export const fetchAdminData = (...args) => {
    return endpointWrapper({ domain: 'admin', ...args[0] });
};
